import { getAreAllTicketsSoldOut } from '../../selectors/tickets';
import { CheckoutState } from '../../state';

export const getUrgencySignals = (state: CheckoutState) =>
    !getAreAllTicketsSoldOut(state) ? state.app.urgencySignals : null;
